import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3578e5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Send a friend request ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Remove from friends ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Accept a friend request ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Reject a friend request ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_12 = { class: "left" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Send a friend request ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Remove from friends ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Accept a friend request ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Reject a friend request ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_drive_add_menu_pop_up = _resolveComponent("drive-add-menu-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
        key: 0,
        onHide: _ctx.hidePopUp,
        "hide-bottom-decoration": "",
        "hide-top-decoration": ""
      }, {
        title: _withCtx(() => [
          _hoisted_1
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.status === _ctx.CONTACT_STATUS.NO_CONTACT)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 0,
                  class: "pd-12",
                  onClick: _ctx.requestContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.CONTACT)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 1,
                  class: "pd-12",
                  onClick: _ctx.deleteContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_6
                  ]),
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.REQUEST_RECEIVED)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 2,
                  class: "pd-12",
                  onClick: _ctx.acceptContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.REQUEST_RECEIVED)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 3,
                  class: "pd-12",
                  onClick: _ctx.rejectContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onHide"]))
    : (_openBlock(), _createBlock(_component_drive_add_menu_pop_up, {
        key: 1,
        desktopPopUpPosition: _ctx.positionData,
        onHide: _ctx.hidePopUp,
        "hide-bottom-decoration": "",
        "hide-top-decoration": ""
      }, {
        title: _withCtx(() => [
          _hoisted_11
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.status === _ctx.CONTACT_STATUS.NO_CONTACT)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 0,
                  class: "pd-12",
                  onClick: _ctx.requestContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_14
                  ]),
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.CONTACT)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 1,
                  class: "pd-12",
                  onClick: _ctx.deleteContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_16
                  ]),
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.REQUEST_RECEIVED)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 2,
                  class: "pd-12",
                  onClick: _ctx.acceptContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.status === _ctx.CONTACT_STATUS.REQUEST_RECEIVED)
              ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  key: 3,
                  class: "pd-12",
                  onClick: _ctx.rejectContact
                }, {
                  icon: _withCtx(() => [
                    _hoisted_20
                  ]),
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["desktopPopUpPosition", "onHide"]))
}